module.exports = __webpack_public_path__ + "assets/img/rakumart-espana.efad6fcc.png";